<template>
</template>

<script>
export default {
  data: () => ({
    showing_extra: false,
    icons: [],
   tabs: null,
   text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ' +
           'eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, ' +
           'quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',


    links: [
      { name: 'Sitemap', Link: 'https://bnc.com' },
      { name: 'About Us', Link: 'https://bnc.com' },
    ]
  })
}
</script>

<style>

</style>
